import React, { Component } from "react";
import { Modal, TreeSelect } from "antd";
import PropTypes from "prop-types";
const { SHOW_PARENT } = TreeSelect;

class AddToGroup extends Component {
  // 默认属性
  static defaultProps = {
    newSecondSelectColor: "#1E9FFF",
  };
  // 静态类型分析
  static propTypes = {
    currentLeftMenuList: PropTypes.array.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      value: null,
    };
  }
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.props.getAddGroups(this.state.value);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  render() {
    console.log(this.props.currentLeftMenuList)
    const treeData = JSON.parse(
      JSON.stringify(this.props.currentLeftMenuList)
        .replace(/name/g, "title")
        .replace(/sons/g, "children")
        .replace(/id/g, "value")
    );
    console.log(treeData);
    return (
      <div>
        <Modal
          centered
          title="选择分组"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="380px"
          bodyStyle={{ height: "200px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div>分组</div>
            <div>
              <TreeSelect
                treeData={treeData}
                value={this.state.value}
                onChange={this.onChange}
                treeCheckable={true}
                showCheckedStrategy={SHOW_PARENT}
                searchPlaceholder="请选择"
                style={{
                  width: "200px",
                }}
                dropdownStyle={{ height: "130px" }}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  onChange = (value) => {
    this.setState({
      value,
    });
  };
}

export default AddToGroup;
